import * as types from './types';

export default {    
    [types.ACTIONS_UPDATE_ZIPCODE]: ({commit}, payload) => {
        commit(types.MUTATE_UPDATE_ZIPCODE, payload)
    },    
    [types.ACTIONS_UPDATE_RENTALCONTAINERSLIST]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_RENTALCONTAINERSLIST, payload)
    },    
    [types.ACTIONS_UPDATE_DOORDIRECTION]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_DOORDIRECTION, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERYSPACE]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_DELIVERYSPACE, payload)
    },
    [types.ACTIONS_UPDATE_CONTAINERCONDITION]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_CONTAINERCONDITION, payload)
    },
    [types.ACTIONS_UPDATE_TWOMONTHS]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_TWOMONTHS, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERYINSTRUCTIONS]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_DELIVERYINSTRUCTIONS, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERYCONTACTNAME]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_DELIVERYCONTACTNAME, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERYCONTACTPHONE]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_DELIVERYCONTACTPHONE, payload)
    },
    [types.ACTIONS_UPDATE_CARTLINEITEM]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_CARTLINEITEM, payload)
    },
    [types.ACTIONS_UPDATE_EMPTYCART]: ({commit}) => {        
        commit(types.MUTATE_UPDATE_EMPTYCART)
    },   
    [types.ACTIONS_UPDATE_UNACCEPTABLEDATES]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_UNACCEPTABLEDATES, payload)
    },    
    [types.ACTIONS_UPDATE_TERMSNCONDITIONS]: ({commit}, payload) => {        
        commit(types.MUTATAE_UPDATE_TERMSNCONDITIONS, payload)
    },
    [types.ACTIONS_UPDATE_PREDELIVERYANSWERS]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_PREDELIVERYANSWERS, payload)
    },
    [types.ACTIONS_UPDATE_PREDELIVERYANSWERSDEFAULT]: ({commit}) => {        
        commit(types.MUTATE_UPDATE_PREDELIVERYANSWERSDEFAULT)
    },
    [types.ACTIONS_UPDATE_MOVECONTAINERS]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_MOVECONTAINERS, payload)
    },
    [types.ACTIONS_UPDATE_RENTALSDURATION]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_RENTALSDURATION, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERYSURFACETYPE]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_DELIVERYSURFACETYPE, payload)
    },
    [types.ACTIONS_UPDATE_SOFTSURFACEACKNOWLEDGE]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_SOFTSURFACEACKNOWLEDGE, payload)
    },
    [types.ACTIONS_UPDATE_COUNTRY_CODE]: ({commit}, payload) => {        
        commit(types.MUTATE_UPDATE_COUNTRY_CODE, payload)
    },
};